import { useMediaQuery } from './useMediaQuery';

/** Shared responsive breakpoints (CSS must stay in sync). */
export const BREAKPOINTS = {
  mobileMax: 767,
  tabletMin: 768,
  tabletMax: 1023,
  desktopMin: 1024,
} as const;

export type BreakpointName = 'mobile' | 'tablet' | 'desktop';

export function useBreakpoint(): {
  breakpoint: BreakpointName;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  /** Sidebar on desktop; drawer + top bar below desktop width. */
  isCompactNav: boolean;
} {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.mobileMax}px)`);
  const isTablet = useMediaQuery(
    `(min-width: ${BREAKPOINTS.tabletMin}px) and (max-width: ${BREAKPOINTS.tabletMax}px)`,
  );
  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.desktopMin}px)`);
  const breakpoint: BreakpointName = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
  return {
    breakpoint,
    isMobile,
    isTablet,
    isDesktop,
    isCompactNav: !isDesktop,
  };
}
